import React, { useState } from "react";

function BalakrishnaTemple() {
 return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/bg.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}>
      </div>
      <div className="" style={{backgroundImage:'url(./images/event.jpeg)',padding:'10px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}>
            
            <div className="col-md-12" style={{background:'#ffeccaf6',padding:'90px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange',borderRadius:'15px'}}>
                    <div className="col-md-8" style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',flexWrap:'wrap',gap:'25px'}}>
                       <center><p className="enquiry" style={{fontSize:'34pt',padding:'15px',lineHeight:'60px',fontWeight:'700'}}>Abhedashramam <br></br>Sree Balakrishna Swami <br />Devaswom Trust</p> </center> 
                      
                       <p className="enquiry" style={{color:'black',marginTop:'-20px',textAlign:'justify',padding:'50px',lineHeight:'25pt',fontSize:'12pt'}}>The administration of Arayoor & Trivandrum Ashramam is vested with Abhedashramam Sree Balakrishnan Swamy Devaswom Trust, Trivandrum which was registered in 1963. The Trust is presently headed by Sri Choozhal A Krishnan Potti, a staunch disciple of Gurudev. Swami Kesavananda Bharathi is the Vice President, Sri. Ramkumar V, General Secretary, and Sri.S. Balachandran Nair, Treasurer. Sri. Manikantan is the secretary of Arayoor Ashramam.
                       <br /> (Refer separate section for the list of office bearers and other members)
</p>
                    </div>
                    <div className="col-md-4" style={{backgroundImage:'url(./images/bala.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}> 
                        {/* <img src="./images/bala.jpeg" alt="Guruji" style={{width:'100%'}} /> */}
                    </div>
                </div>
                
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    
                    {/* details */}
                    <div className="row" style={{marginBottom:'50px',background:'white',borderRadius:'15px'}}>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Annual Festival</h1>
                            <p>
                                The annual Festival of the Balakrishna Swamy Temple is celebrated for seven days from Pooyam star in Meenam as per Tantric rules.

                            </p>
                            <div className="nexttimeline">
                              <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                        </div>
                            
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Daily Pooja</h1>
                            <p>
                                Poojas are systematically done in all temples and the Akhanda Nama Japa podium (Namavedhi).
                            </p>
                             <div className="nexttimeline">
                                 <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Other celebration</h1>
                            <p>
                                Gurudev’s Birthday (Star Visakham in the month Meenam) is celebrated at both the Ashramams with various spiritual and cultural Programmes. The annual Abhedananda Music Festival is conducted during this period.
                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>The Maha Samadhi Day</h1>
                            <p>
                                (29th October and Ayilyam in thulam) is observed in both the Ashramams in the most befitting manner.
The Ladies wing:- Visakham Sangham
On all Visakham (Birth star of Gurudev) star dates, the Visakha Sangam performs Mahamantra Laksharchana in the Namavedi. On all other days, they perform one hour archana in the Namavedi. They actively participate in all cultural & spiritual activities of the Ashramam.


                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Other Daily Activities</h1>
                            <p>
                                On all days there are Bhajans conducted at the Ashram auditorium. Discourses on various spiritual texts and treatises are conducted. Various classes on spirituality are also conducted by eminent personalities in this field.


                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Abhedasramam Paramabhattaraka Cultural Development Society</h1>
                            <p>
                                Abhedasramam Paramabhattaraka Cultural Development Society was formed in 1970 to coordinate the arts & cultural activities of the Ashram. The Society, runs a book stall in the Ashram and publishes spiritual books especially those written by Gurudev. Under the aegis of the Society, there is a Sangeetha Sabha which organises music concerts monthly and the annual music festival.
Temples inside the Ashrama, Thiruvananthapuram
Sri. Balakrishna Swamy Temple is the main temple in this Ashramam. Shrines of Sree Mahaganapathy, Sree Anjaneyan, Sree Ayyappan, Sree Balasubramonian, and Sree Chattambi Swamigal were consecreated.
Sri. Radha Devi Vigraha (Idol) in marble is installed facing Sri. Balakrishna Swamy. After the Maha Samadhi of Gurudev the devotees have installed Gurudev’s idol near the Radha Mandapam.



                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>  
                        
                        
                        
                        
                    </div>
                
                   
                </div>
                
                
           </div> 
          
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default BalakrishnaTemple;